export default __webpack_public_path__ + "static/media/sword3.854b9853.svg";